/**
 * Trade Join Page — choice gate and registration form with invitation-token support.
 *
 * Loaded by sections/trade-join.liquid.
 * Handles the initial account path selection, form validation,
 * email-duplicate checks, and auto-login after successful registration.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const joinRoot = document.querySelector('[data-trade-join]');
    const gate = document.querySelector('[data-trade-join-gate]');
    const formPanel = document.querySelector('[data-trade-join-form]');
    const showFormButtons = document.querySelectorAll('[data-trade-join-show-form]');
    const backButton = document.querySelector('[data-trade-join-back]');

    function showSelectedForm() {
      if (!joinRoot || !gate || !formPanel) return;

      gate.hidden = true;
      formPanel.hidden = false;
      joinRoot.classList.add('trade-join--form-active');
    }

    function showGate() {
      if (!joinRoot || !gate || !formPanel) return;

      formPanel.hidden = true;
      gate.hidden = false;
      joinRoot.classList.remove('trade-join--form-active');
    }

    showFormButtons.forEach(function (button) {
      button.addEventListener('click', showSelectedForm);
    });

    if (backButton) {
      backButton.addEventListener('click', showGate);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const shouldOpenApplication = urlParams.get('trade_apply') === '1';
    const inviteToken = urlParams.get('invite');
    const isLoggedIn = joinRoot && joinRoot.getAttribute('data-customer-logged-in') === 'true';
    if (inviteToken || (shouldOpenApplication && isLoggedIn)) {
      showSelectedForm();
    }

    const form = document.getElementById('register-form');
    if (!form) return; // Only runs for non-logged-in users

    const submitBtn = document.getElementById('register-form-submit');
    const errorDiv = document.getElementById('register-form-error');
    const passwordField = document.getElementById('reg-password');
    const confirmField = document.getElementById('reg-password-confirm');
    const emailField = document.getElementById('reg-email');

    if (inviteToken) {
      tradeFetch(window.tradeApiBase + '/users/invitations/' + encodeURIComponent(inviteToken) + '/validate', undefined, { source: 'TradeJoin.validateInvitation' })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          // Show invitation notice
          const notice = document.createElement('div');
          notice.className = 'invitation-notice';
          notice.appendChild(document.createTextNode('You\'ve been invited to join '));
          const strong = document.createElement('strong');
          strong.textContent = data.companyName;
          notice.appendChild(strong);
          notice.appendChild(document.createTextNode('. Company details have been pre-filled.'));
          form.insertBefore(notice, form.firstChild);

          // Prefill and lock email
          emailField.value = data.email;
          emailField.setAttribute('readonly', true);

          // Prefill hidden values
          document.getElementById('reg-company-name').value = data.companyName;
          document.getElementById('reg-address1').value = data.companyAddress.address1 || '';
          document.getElementById('reg-address2').value = data.companyAddress.address2 || '';
          document.getElementById('reg-city').value = data.companyAddress.city || '';
          document.getElementById('reg-state').value = data.companyAddress.state || '';
          document.getElementById('reg-zip').value = data.companyAddress.zipPostalCode || '';
          document.getElementById('reg-country').value = data.companyAddress.country || 'United States';

          // Remove required from hidden fields
          ['reg-company-name', 'reg-business-website', 'reg-business-type', 'reg-business-type-other', 'reg-address1', 'reg-city', 'reg-state', 'reg-zip', 'reg-country'].forEach(function (id) {
            document.getElementById(id).removeAttribute('required');
          });

          // Hide fields not needed for invited users — remove from layout but keep in DOM for payload
          const hiddenFieldIds = ['reg-company-name', 'reg-business-website', 'reg-business-type', 'reg-business-type-other'];
          hiddenFieldIds.forEach(function (id) {
            const el = document.getElementById(id);
            if (el) {
              const wrapper = el.closest('.trade-form-field');
              if (wrapper) { wrapper.style.display = 'none'; }
            }
          });

          // Move visible fields into a single flex row so they pair up without gaps
          const visibleIds = ['reg-first-name', 'reg-last-name', 'reg-email', 'reg-phone', 'reg-role-title', 'reg-password', 'reg-password-confirm'];
          const section = form.querySelector('.trade-form-section');
          const rows = section.querySelectorAll('.trade-form-row');
          const newRow = document.createElement('div');
          newRow.className = 'trade-form-row';
          newRow.style.flexWrap = 'wrap';
          visibleIds.forEach(function (id) {
            const el = document.getElementById(id);
            if (el) newRow.appendChild(el.closest('.trade-form-field'));
          });
          // Preserve hidden fields by moving them out of old rows before destroying them
          hiddenFieldIds.forEach(function (id) {
            const el = document.getElementById(id);
            if (el) {
              const wrapper = el.closest('.trade-form-field');
              if (wrapper) section.appendChild(wrapper);
            }
          });
          // Remove old rows and insert new one after heading
          rows.forEach(function (r) { r.remove(); });
          section.appendChild(newRow);

          // Hide address section
          const addressSection = document.getElementById('address-section');
          if (addressSection) addressSection.style.display = 'none';
        })
        .catch(function (error) {
          const notice = document.createElement('div');
          notice.className = 'invitation-error-notice';
          notice.textContent = 'This invitation link is invalid or has expired. Please contact your company admin for a new invitation.';
          form.insertBefore(notice, form.firstChild);
        });
    }

    // ---- "Other" field toggle helper ----
    function setupOtherToggle(selectId, wrapperId, inputId) {
      const select = document.getElementById(selectId);
      const wrapper = document.getElementById(wrapperId);
      const input = document.getElementById(inputId);

      select.addEventListener('change', function () {
        if (this.value === 'Other') {
          wrapper.style.display = '';
          input.setAttribute('required', '');
        } else {
          wrapper.style.display = 'none';
          input.removeAttribute('required');
          input.value = '';
        }
      });
    }

    setupOtherToggle('reg-business-type', 'reg-business-type-other-wrapper', 'reg-business-type-other');
    setupOtherToggle('reg-referral-source', 'reg-referral-source-other-wrapper', 'reg-referral-source-other');

    // ---- Password validation ----
    function checkPasswordMatch() {
      if (confirmField.value && passwordField.value !== confirmField.value) {
        errorDiv.textContent = "Passwords don't match";
        errorDiv.style.display = 'block';
      } else if (errorDiv.textContent === "Passwords don't match") {
        errorDiv.style.display = 'none';
      }
    }

    function checkPasswordSpaces(field) {
      if (field.value !== field.value.trim()) {
        field.setCustomValidity('Password cannot start or end with spaces');
      } else {
        field.setCustomValidity('');
      }
    }

    confirmField.addEventListener('keyup', checkPasswordMatch);
    passwordField.addEventListener('keyup', function () {
      checkPasswordMatch();
      checkPasswordSpaces(passwordField);
    });

    // ---- Form submission ----
    submitBtn.addEventListener('click', function (e) {

      errorDiv.style.display = 'none';

      // Validate required fields
      const requiredFields = [
        { id: 'reg-first-name', label: 'First name' },
        { id: 'reg-last-name', label: 'Last name' },
        { id: 'reg-company-name', label: 'Company name' },
        { id: 'reg-email', label: 'Email' },
        { id: 'reg-phone', label: 'Phone' },
        { id: 'reg-business-website', label: 'Business website' },
        { id: 'reg-role-title', label: 'Role/Title' },
        { id: 'reg-business-type', label: 'Business type' },
        { id: 'reg-password', label: 'Password' },
        { id: 'reg-password-confirm', label: 'Confirm password' },
        { id: 'reg-business-type-other', label: 'Business type (other)' },
        { id: 'reg-referral-source', label: 'How did you hear about Harbour' },
        { id: 'reg-referral-source-other', label: 'Referral source (other)' },
        { id: 'reg-address1', label: 'Street address' },
        { id: 'reg-city', label: 'City' },
        { id: 'reg-state', label: 'State' },
        { id: 'reg-zip', label: 'Zip code' },
      ];

      const missing = [];
      for (let i = 0; i < requiredFields.length; i++) {
        const field = document.getElementById(requiredFields[i].id);
        if (field && field.hasAttribute('required') && !field.value.trim()) {
          missing.push(requiredFields[i].label);
        }
      }

      if (missing.length > 0) {
        errorDiv.textContent = 'Please fill in: ' + missing.join(', ');
        errorDiv.style.display = 'block';
        return;
      }

      // Validate email format
      const emailVal = emailField.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        errorDiv.textContent = 'Please enter a valid email address';
        errorDiv.style.display = 'block';
        return;
      }

      // Password length (HTML minlength/maxlength; form uses novalidate + button click)
      const pwdVal = passwordField.value;
      if (pwdVal.length < 5 || pwdVal.length > 40) {
        errorDiv.textContent = 'Password must be between 5 and 40 characters';
        errorDiv.style.display = 'block';
        return;
      }
      if (pwdVal !== pwdVal.trim()) {
        errorDiv.textContent = 'Password cannot start or end with spaces';
        errorDiv.style.display = 'block';
        return;
      }

      // Check password match
      if (passwordField.value !== confirmField.value) {
        errorDiv.textContent = "Passwords don't match";
        errorDiv.style.display = 'block';
        return;
      }

      // ZIP format (matches reg-zip pattern in trade-registration-form.liquid)
      const zipEl = document.getElementById('reg-zip');
      if (zipEl) {
        const zipVal = zipEl.value.trim();
        if (zipEl.hasAttribute('required') || zipVal) {
          if (!/^\d{5}(-\d{4})?$/.test(zipVal)) {
            errorDiv.textContent = 'Enter a valid US ZIP code (e.g. 90210 or 90210-1234)';
            errorDiv.style.display = 'block';
            return;
          }
        }
      }

      // Website format — bare domain only, keep in sync with BusinessWebsiteSchema
      // in the middleware (skipped for invited signups, where the field is hidden)
      const websiteEl = document.getElementById('reg-business-website');
      if (websiteEl && websiteEl.hasAttribute('required')) {
        const websiteVal = websiteEl.value.trim();
        if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(websiteVal)) {
          errorDiv.textContent = 'Please enter a valid website, like yourstudio.com';
          errorDiv.style.display = 'block';
          return;
        }
      }

      // Remove any previous email warning
      const existingWarning = form.querySelector('.email-exists-warning');
      if (existingWarning) existingWarning.remove();

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      errorDiv.style.display = 'none';

      const payload = {
        firstName: document.getElementById('reg-first-name').value.trim(),
        lastName: document.getElementById('reg-last-name').value.trim(),
        email: document.getElementById('reg-email').value.trim(),
        password: passwordField.value,
        passwordConfirmation: confirmField.value,
        phone: document.getElementById('reg-phone').value.trim(),
        roleTitle: document.getElementById('reg-role-title').value.trim(),
      };

      if (inviteToken) {
        payload.invitationToken = inviteToken;
      }

      // Referral source (included for both invited and normal signups)
      payload.referralSource = document.getElementById('reg-referral-source').value;
      if (payload.referralSource === 'Other') {
        payload.referralSourceOther = document.getElementById('reg-referral-source-other').value.trim();
      }

      // Only include company fields for non-invited signups
      if (!inviteToken) {
        payload.companyName = document.getElementById('reg-company-name').value.trim();
        payload.businessWebsite = document.getElementById('reg-business-website').value.trim();
        payload.businessType = document.getElementById('reg-business-type').value;
        if (payload.businessType === 'Other') {
          payload.businessTypeOther = document.getElementById('reg-business-type-other').value.trim();
        }
        payload.address = {
          address1: document.getElementById('reg-address1').value.trim(),
          address2: document.getElementById('reg-address2').value.trim(),
          city: document.getElementById('reg-city').value.trim(),
          state: document.getElementById('reg-state').value,
          zipPostalCode: document.getElementById('reg-zip').value.trim(),
          country: document.getElementById('reg-country').value,
        };
      }

      // Check email duplicate, then register
      tradeFetch(window.tradeApiBase + '/users/check-email?email=' + encodeURIComponent(payload.email), undefined, { source: 'TradeJoin.checkEmail' })
        .then(function (r) { return r.json(); })
        .then(function (checkData) {
          if (checkData.exists) {
            const warning = document.createElement('div');
            warning.className = 'email-exists-warning';
            warning.appendChild(document.createTextNode('This email is already registered. '));
            const loginLink = document.createElement('a');
            loginLink.href = '/account/login?return_url=' + encodeURIComponent('/pages/join?trade_apply=1');
            loginLink.textContent = 'Log in to apply for trade';
            warning.appendChild(loginLink);
            emailField.closest('.trade-form-field').appendChild(warning);
            submitBtn.disabled = false;
            submitBtn.textContent = 'Apply for an account';
            return;
          }

          return tradeFetch(window.tradeApiBase + '/users/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }, { source: 'TradeJoin.register' })
            .then(function (response) {
              return response.json();
            })
            .then(function () {
              function submitLoginForm() {
                // Auto-login via hidden form POST to Shopify
                const loginForm = document.createElement('form');
                loginForm.method = 'post';
                loginForm.action = '/account/login';
                loginForm.style.display = 'none';
                function addHiddenInput(form, name, value, type) {
                  const input = document.createElement('input');
                  input.type = type || 'hidden';
                  input.name = name;
                  input.value = value;
                  form.appendChild(input);
                }
                addHiddenInput(loginForm, 'return_to', '/pages/dashboard');
                addHiddenInput(loginForm, 'customer[email]', payload.email, 'email');
                addHiddenInput(loginForm, 'customer[password]', payload.password, 'password');
                document.body.appendChild(loginForm);
                loginForm.submit();
              }

              if (!inviteToken && window.pushTradeApplicationSignUp) {
                window.pushTradeApplicationSignUp(payload, submitLoginForm);
                return;
              }

              submitLoginForm();
            });
        })
        .catch(function (error) {
          if (error === 'email_exists') return;
          errorDiv.textContent = error.status && error.status < 500
            ? error.message
            : 'We weren\'t able to complete your registration. Please try again or contact us for assistance.';
          errorDiv.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Apply for an account';
        });
    });
  });
})();
